export default {
	createPayment({ type, amount }, cb) {
		this.http
			.post('/pay/createPayment/', { type, amount })
			.then((response) => {
				cb(response)
			})
	},

	getPayments(order, payments, cb) {
		this.http
			.get('/order/getPayment/' + order.order_sn, {
				params: payments
			})
			.then((response) => {
				cb(response)
			})
	},
	getPaymentById(id, cb) {
		this.http.get(`/order/getPaymentById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	getOrder(orderNo, cb, ecb) {
		this.http
			.get(`/order/getOrder/${orderNo}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	createOrder(form, cb) {
		//第一步创建订单内容 - 这里不同类型的订单创建方法不一样
		throw new Error('The order should not be created here')
	},
	placeOrder(orderNo, payitems, cb) {
		//第二步 创建支付项，如果支付项已经完成（剩余金额=0），则直接在后端settle
		//前端算一次剩余支付额（leftover）显示给用户，后端再算一次，返回对应的支付接口
		//如果leftover = 0， 则直接用户确定后 settle后端提交
		this.http.post('/order/placeOrder/' + orderNo, payitems).then((r) => {
			cb(r)
		})
	},
	settleOrder(form, cb) {
		//第三步，如果前端获得leftover的支付结果，调用这里，否则一般是后端（收到支付渠道的通知后）调用settle，但前端需要等待一下
		this.http.post('/order/settle', form).then((response) => {
			cb(response)
		})
	},
	getWechatPackage(form, cb) {
		this.http.post('/pay/getWechatPackage', form).then((response) => {
			cb(response)
		})
	},
	getWechatAppPackage(form, cb) {
		this.http.post('/pay/getWechatAppPackage', form).then((response) => {
			cb(response)
		})
	},
	getWechatMobileAppPackage(form, cb) {
		this.http
			.post('/pay/getWechatMobileAppPackage', form)
			.then((r) => cb && cb(r))
	},
	getWechatMwebUrl(ordersn, paymentId, cb) {
		this.http
			.get('/pay/getWechatMwebUrl/' + ordersn + '/' + paymentId, {})
			.then((response) => {
				cb(response)
			})
	},
	getWechatCodeUrl(ordersn, paymentId, cb) {
		this.http
			.get('/pay/getWechatCodeUrl/' + ordersn + '/' + paymentId, {})
			.then((response) => {
				cb(response)
			})
	},
	getAliPayPackage(form, cb) {
		this.http.post('/pay/aliPayPackage', form).then((response) => {
			cb(response)
		})
	},
	getAliPayString(form, cb) {
		this.http.post('/pay/aliPayString', form).then((response) => {
			cb(response)
		})
	},
	getAliPayMobileAppPackage(form, cb) {
		this.http.post('/pay/aliPayMobileAppPackage', form).then((response) => {
			cb(response)
		})
	},
	accountPay(orderNo, paymentId, cb) {
		this.http
			.post('/pay/accountPay/' + orderNo + '/' + paymentId, {})
			.then((response) => {
				cb(response)
			})
	},
	posSubmit(params, cb, ecb) {
		this.http
			.post(`/pay/posSubmit`, params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	orderStatus(ordersn, config, cb, ecb) {
		this.http
			.post(`/pay/status/${ordersn}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	createPaymentOrder(form, cb) {
		this.http.post('/pay/createPaymentOrder', form).then((r) => cb && cb(r))
	}
}
